import { createFileRoute } from '@tanstack/react-router';
import { HStack, VStack } from '@/components/Layout';
import { AddStepperCompleteDialog } from '@/components/Stepper';
import Processing from '@/features/import-csv/-components/Processing';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { LIST_EMPTY_DATA } from '@/lib/listPage';
import AddStepperNavigation from '../-components/AddStepperNavigation';
import AddStepperPanelProgress from '../-components/AddStepperPanelProgress';
import AddStepperStepTitleCard from '../-components/AddStepperStepTitleCard';
import BasicForm from '../-components/BasicForm';
import SelectCategoryPermission from '../-components/SelectCategoryPermission';
import SelectPeopleGroup from '../-components/SelectPeopleGroup';
import SelectPermission from '../-components/SelectPermission';
import { ROLE_CREATE_HASH } from '../-constants';
import useBasicForm from '../-hooks/useBasicForm';
import useHash from '../-hooks/useHash';
import useSelectCategoryPermission from '../-hooks/useSelectCategoryPermission';
import useSelectPeopleGroup from '../-hooks/useSelectPeopleGroup';
import useSelectPermission from '../-hooks/useSelectPermission';
import useCreateRole from '../-mutations/useCreateRole';
import { TabKey } from '../../../_list/roles/-constants';
import useGetRoles from '../../../_list/roles/-queries/useGetRoles';
export const Route = createFileRoute('/_staff/settings/permission-and-roles/_form/roles/new/')({
  component: RouteComponent
});
const BASE_LINK = '/settings/permission-and-roles/roles/new';
function RouteComponent() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.settings.permissionAndRoles.createRole'
  });
  const {
    hash
  } = useHash();
  const {
    data: rolesRes
  } = useGetRoles({
    search: {
      category: TabKey.ALL,
      pageIndex: 0,
      pageSize: 100
    }
  });
  const {
    basicFormState,
    handleChange,
    isDuplicateName
  } = useBasicForm({
    data: undefined,
    existingRoles: rolesRes ?? LIST_EMPTY_DATA
  });
  const {
    selectPeopleGroupState,
    handleChangeSelectedOptions
  } = useSelectPeopleGroup({
    data: undefined
  });
  const {
    selectPermissionState,
    handleChangeSelectedOptions: handleChangeSelectedPermissions
  } = useSelectPermission({
    data: undefined
  });
  const {
    mutate: createRole,
    isPending,
    isComplete
  } = useCreateRole();
  const {
    selectCategoryPermissionState,
    handleChangeSelectedOptions: handleChangeSelectedCategoryPermissions
  } = useSelectCategoryPermission({
    data: undefined
  });
  return <HStack className="gap-9 p-10 h-[calc(100vh-64px)]">
      <AddStepperNavigation baseLink={BASE_LINK} currentHash={hash} />

      <VStack className="gap-6 w-full">
        {isPending && <Processing hash={hash} />}

        {!isPending && <AddStepperStepTitleCard hash={hash} />}

        {!isPending && hash === ROLE_CREATE_HASH.FORM && <BasicForm basicFormState={basicFormState} handleChange={handleChange} isDuplicateName={isDuplicateName} />}

        {!isPending && hash === ROLE_CREATE_HASH.SELECT_PEOPLE_GROUP && <SelectPeopleGroup selectPeopleGroupState={selectPeopleGroupState} handleChangeSelectedOptions={handleChangeSelectedOptions} />}

        {!isPending && hash === ROLE_CREATE_HASH.SET_PERMISSION && <SelectPermission selectPermissionState={selectPermissionState} handleChangeSelectedOptions={handleChangeSelectedPermissions} />}

        {!isPending && hash === ROLE_CREATE_HASH.SELECT_CATEGORY_PERMISSION && <SelectCategoryPermission selectCategoryPermissionState={selectCategoryPermissionState} handleChangeSelectedOptions={handleChangeSelectedCategoryPermissions} />}

        {!isPending && <AddStepperPanelProgress baseLink={BASE_LINK} currentHash={hash} basicFormState={basicFormState} selectPeopleGroupState={selectPeopleGroupState} selectPermissionState={selectPermissionState} selectCategoryPermissionState={selectCategoryPermissionState} mutate={createRole} isDuplicateName={isDuplicateName} />}

        {isComplete && <AddStepperCompleteDialog completeMessage={t('addStepperCompleteDialog.create.completeMessage')} completeLinkButtonText={t('addStepperCompleteDialog.create.completeLinkButtonText')} completeLinkUrl="/settings/permission-and-roles/roles" />}
      </VStack>
    </HStack>;
}